export default __webpack_public_path__ + "static/media/banner 16-9 elfs-01.0a33e1b3.png";